import _ from 'lodash';
import type { IframeHTMLAttributes, ReactNode } from 'react';
import React, { useEffect, useRef, useState } from 'react';

interface IframeWithFallbackProps
  extends IframeHTMLAttributes<HTMLIFrameElement> {
  fallback: ReactNode;
}

const IframeWithFallback = ({
  fallback,
  ...props
}: IframeWithFallbackProps) => {
  const nameRef = useRef<string | null>(null);

  const getIframeName = () => {
    if (nameRef.current) {
      return nameRef.current;
    }
    const name = _.uniqueId('iframe_with_fallback');
    nameRef.current = name;
    return name;
  };

  const [isShowingFallback, setIsShowingFallback] = useState(false);

  useEffect(() => {
    const removeListener = window.desktop?.onIframeBlock?.(
      getIframeName(),
      () => {
        setIsShowingFallback(true);
      },
    );
    return removeListener;
  }, []);

  return isShowingFallback ? (
    <>{fallback}</>
  ) : (
    // eslint-disable-next-line jsx-a11y/iframe-has-title
    <iframe name={getIframeName()} {...props} />
  );
};

export default IframeWithFallback;
